function formatCurrency(value) {
  if (value !== '' && value !== null) {
    return parseInt(value).toLocaleString().replace(/,/g, ' ');
  } else {
    return null;
  }
}

function parseCurrency(value) {
  const num = Number(value.replace(/\s/g, ''));
  return num || num == 0 ? num : null;
}

function isNumberCheck(evt) {
  evt = evt ? evt : window.event;
  var charCode = evt.which ? evt.which : evt.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    evt.preventDefault();
  } else {
    return true;
  }
}

export { formatCurrency, parseCurrency, isNumberCheck };
